import React from 'react';
import { motion } from 'framer-motion';
interface AmbientProps {
  /** 'cover' is the grandest treatment, 'quiet' the most restrained. */
  variant?: 'cover' | 'default' | 'quiet';
  grid?: boolean;
}

/**
 * Bright ambient backdrop — a soft, luminous white canvas with the faintest
 * Vexu green light bloom. Motion is continuous and very slow: it reads as
 * atmosphere, never as UI.
 */
export function Ambient({
  variant = 'default',
  grid = false
}: AmbientProps) {
  const intensity = variant === 'cover' ? 1 : variant === 'quiet' ? 0.45 : 0.7;
  return <div className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-438" data-mp="3ldc75pprywj1">
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse 75% 55% at 50% -12%, rgba(0,200,83,0.10) 0%, transparent 62%), radial-gradient(ellipse 55% 45% at 6% 108%, rgba(0,200,83,0.06) 0%, transparent 60%), linear-gradient(180deg, #FFFFFF 0%, #F8FBF9 45%, #F2F6F3 100%)'
    }} data-id="element-439" data-mp="36ltqrqt06zz5" />

      {grid && <div className="absolute inset-0" style={{
      backgroundImage: 'linear-gradient(to right, rgba(15,23,42,0.05) 1px, transparent 1px)',
      backgroundSize: '80px 100%',
      maskImage: 'radial-gradient(ellipse 65% 70% at 50% 45%, black 0%, transparent 78%)',
      WebkitMaskImage: 'radial-gradient(ellipse 65% 70% at 50% 45%, black 0%, transparent 78%)'
    }} data-id="element-440" data-mp="3q0239hods6my" />}

      <motion.div aria-hidden="true" className="absolute rounded-full blur-[150px]" style={{
      width: 820,
      height: 820,
      left: '48%',
      top: -470,
      background: 'rgba(0,200,83,0.20)',
      opacity: intensity * 0.85
    }} animate={{
      scale: [1, 1.07, 1]
    }} transition={{
      duration: 18,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-441" data-mp="7lj5nc9z9eqp" />
      <motion.div aria-hidden="true" className="absolute rounded-full blur-[160px]" style={{
      width: 660,
      height: 660,
      left: -300,
      top: 380,
      background: 'rgba(0,200,83,0.12)',
      opacity: intensity * 0.8
    }} animate={{
      scale: [1.06, 1, 1.06]
    }} transition={{
      duration: 22,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-442" data-mp="2jbvfb8tlay4h" />

      <div className="absolute inset-x-0 top-0 h-px" style={{
      background: 'linear-gradient(90deg, transparent 0%, rgba(15,23,42,0.10) 50%, transparent 100%)'
    }} data-id="element-443" data-mp="1153w0bp4j6w9" />
    </div>;
}